const apiBaseUrlRaw = import.meta.env.VITE_API_BASE_URL as string | undefined;
const enableEmailCaptureFlag = import.meta.env.VITE_ENABLE_EMAIL_CAPTURE as string | undefined;
const metaDedupDebugFlag = import.meta.env.VITE_META_DEDUP_DEBUG as string | undefined;
const metaPixelId = import.meta.env.VITE_META_PIXEL_ID as string | undefined;
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL as string | undefined;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined;

const parseBooleanFlag = (value: string | undefined, fallback: boolean): boolean => {
  if (!value) {
    return fallback;
  }

  const normalizedValue = value.trim().toLowerCase();
  if (normalizedValue === "true") {
    return true;
  }
  if (normalizedValue === "false") {
    return false;
  }

  return fallback;
};

const normalizeApiBaseUrl = (value: string | undefined): string => {
  if (!value) {
    return "";
  }
  return value.trim().replace(/\/+$/, "");
};

export const config = {
  /** Stripe checkout backend (`/api/checkout/create-session`). Set `VITE_API_BASE_URL` (e.g. `https://vireo-checkout-api.flowcloud.workers.dev`). */
  apiBaseUrl: normalizeApiBaseUrl(apiBaseUrlRaw),
  metaPixelId: metaPixelId?.trim() ?? "",
  supabaseUrl: supabaseUrl ?? "",
  supabaseAnonKey: supabaseAnonKey ?? "",
  enableEmailCapture: parseBooleanFlag(enableEmailCaptureFlag, true),
  metaDedupDebug: parseBooleanFlag(metaDedupDebugFlag, true)
} as const;
